import React from "react";
import { motion } from "framer-motion";
import FeatureHighlight from "./FeatureHighlight";

const UnlockPotential = () => {
    return (
        <section className="px-5 py-20 mx-auto w-full max-w-screen-xl max-md:py-16 max-sm:py-10">
            <motion.div className="flex flex-wrap gap-12 max-md:gap-10 max-sm:gap-8"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, ease: "easeOut" }}
                viewport={{ once: true }}
            >
                <div className="w-[600px] max-md:w-full">
                    <h1 className="text-4xl font-bold text-black leading-[50.4px] max-sm:text-3xl max-sm:leading-10">
                        <div>
                            <span>Unlock Your Child's</span></div>
                        <span>Potential with</span>
                        <span className="italic"> iExcel </span>
                        <span className="italic"> International English </span>
                        <span>Tuition</span>
                    </h1>
                </div>
                <div className="flex-1">
                    <div className="flex flex-col gap-8">
                        <p className="text-lg leading-normal text-black max-md:text-base max-sm:text-base text-justify">
                            At iExcel International English, we are committed to providing
                            your child with the best possible English education. Our
                            comprehensive tuition programs are designed to help students excel
                            academically and gain confidence in their language skills.
                        </p>
                        <div className="flex gap-6 max-md:flex-wrap">
                            <FeatureHighlight
                                title="Flexibility"
                                description="Online and in-person classes adapt to your schedule."
                            />
                            <FeatureHighlight
                                title="Expertise"
                                description="Experienced instructors dedicated to student success."
                            />
                        </div>
                    </div>
                </div>
            </motion.div>
        </section>
    );
};

export default UnlockPotential;
